module.exports = __webpack_public_path__ + "static/media/pp-trans.f3126e61.png";